/**
 * @file sku-code.ts
 * @description Генератор артикулов SKU (phase07 product-edit).
 *
 * Формат: `{PREFIX}-{YYMMDD}-{RAND4}` — напр. `MILK-260528-K7X3`.
 *  - PREFIX: 3-4 символа из slug товара (UPPER, без дефисов). Дефолт `SKU`.
 *  - YYMMDD: дата создания (год/месяц/день).
 *  - RAND4: 4 символа из алфавита `A-Z2-9` без визуально похожих `0/1/I/O`.
 *
 * Проверяет коллизию с existing-codes; до 10 попыток регенерации (32⁴ = 1M
 * комбинаций, шанс коллизии в реальной нагрузке — около нуля). Сервер всё
 * равно валидирует `@@unique([productId, code])` через 409.
 */

const RAND_ALPHABET = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789"; // без 0/1/I/O

export function generateSkuCode(productSlug: string | undefined, existingCodes: string[]): string {
  const slug = (productSlug ?? "").replace(/-/g, "").toUpperCase();
  const prefix = (slug.slice(0, 4) || "SKU").replace(/[^A-Z0-9]/g, "");

  const now = new Date();
  const yy = String(now.getFullYear() % 100).padStart(2, "0");
  const mm = String(now.getMonth() + 1).padStart(2, "0");
  const dd = String(now.getDate()).padStart(2, "0");
  const date = `${yy}${mm}${dd}`;

  const taken = new Set(existingCodes);
  for (let attempt = 0; attempt < 10; attempt += 1) {
    let rand = "";
    for (let i = 0; i < 4; i += 1) {
      rand += RAND_ALPHABET[Math.floor(Math.random() * RAND_ALPHABET.length)];
    }
    const code = `${prefix}-${date}-${rand}`;
    if (!taken.has(code)) return code;
  }
  // fallback — timestamp-suffix (астрономически маловероятный fallthrough)
  return `${prefix}-${date}-${Date.now().toString(36).slice(-4).toUpperCase()}`;
}
